/**
 * 平滑滚动到顶部，支持用户操作中断
 */
export function scrollToTop() {
  let isInterrupted = false;
  const stopScroll = () => {
    isInterrupted = true;
    window.removeEventListener('wheel', stopScroll);
    window.removeEventListener('touchstart', stopScroll);
    window.removeEventListener('mousedown', stopScroll);
  };

  window.addEventListener('wheel', stopScroll);
  window.addEventListener('touchstart', stopScroll);
  window.addEventListener('mousedown', stopScroll);

  (function smoothscroll() {
    if (isInterrupted) return;
    const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
    if (currentScroll > 0) {
      window.requestAnimationFrame(smoothscroll);
      window.scrollTo(0, currentScroll - Math.max(currentScroll / 10, 1));
    } else {
      stopScroll();
    }
  })();
}



// WEBPACK FOOTER //
// ./src/unitls/scrollUtils.js